export const generateUniqueId = (): string => {
  const timestamp = new Date().getTime().toString()
  // nosemgrep: nodejs_scan.javascript-crypto-rule-node_insecure_random_generator
  const random = Math.random().toString(36).substring(7)
  return `${timestamp}-${random}`
}
